import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductState } from "src/types/product.types";

const initialState: ProductState = {
  createProduct: {
    loading: false,
    data: null,
    error: null,
  },
  editProduct: {
    loading: false,
    data: null,
    error: null,
  },
  productList: {
    loading: false,
    data: null,
    error: null,
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // create product actions
    createProductRequest: (state, action: PayloadAction<any>) => {
      state.createProduct.loading = true;
      state.createProduct.data = null;
      state.createProduct.error = null;
    },
    createProductSuccess: (state, action: PayloadAction<any>) => {
      state.createProduct.loading = false;
      state.createProduct.data = action.payload;
      state.createProduct.error = null;
    },
    createProductError: (state, action: PayloadAction<string>) => {
      state.createProduct.loading = false;
      state.createProduct.data = null;
      state.createProduct.error = action.payload;
    },
    resetCreateProduct: (state) => {
      state.createProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // edit product actions
    editProductRequest: (state, action: PayloadAction<any>) => {
      state.editProduct.loading = true;
      state.editProduct.data = null;
      state.editProduct.error = null;
    },
    editProductSuccess: (state, action: PayloadAction<any>) => {
      state.editProduct.loading = false;
      state.editProduct.data = action.payload;
      state.editProduct.error = null;
    },
    editProductError: (state, action: PayloadAction<string>) => {
      state.editProduct.loading = false;
      state.editProduct.data = null;
      state.editProduct.error = action.payload;
    },
    resetEditProduct: (state) => {
      state.editProduct = {
        loading: false,
        data: null,
        error: null,
      };
    },

    // get product list actions
    getProductListRequest: (
      state,
      action: PayloadAction<{ page: number; limit: number }>
    ) => {
      state.productList.loading = true;
      state.productList.data = null;
      state.productList.error = null;
    },
    getProductListSuccess: (state, action: PayloadAction<any>) => {
      state.productList.loading = false;
      state.productList.data = action.payload;
      state.productList.error = null;
    },
    getProductListError: (state, action: PayloadAction<string>) => {
      state.productList.loading = false;
      state.productList.data = null;
      state.productList.error = action.payload;
    },
    resetProductList: (state) => {
      state.productList = {
        loading: false,
        data: null,
        error: null,
      };
    },
  },
});

export const {
  // create product actions
  createProductRequest,
  createProductSuccess,
  createProductError,
  resetCreateProduct,

  // edit product actions
  editProductRequest,
  editProductSuccess,
  editProductError,
  resetEditProduct,

  // get product list actions
  getProductListRequest,
  getProductListSuccess,
  getProductListError,
} = productSlice.actions;
export default productSlice.reducer;
